import { Bug, LogIn } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useAuth } from "@/context/AuthContext";
import { useLanguage } from "@/i18n/LanguageContext";
import { Navigate } from "react-router-dom";

export default function Login() {
  const { login, isAuthenticated, loading } = useAuth();
  const { t } = useLanguage();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-background grid-bg p-4" data-testid="login-page">
      <Card className="w-full max-w-md bg-card border-border/40">
        <CardHeader className="text-center pb-2">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-14 h-14 rounded-sm bg-primary/20 flex items-center justify-center glow">
              <Bug className="w-8 h-8 text-primary" />
            </div>
          </div>
          <CardTitle className="font-heading text-2xl tracking-widest uppercase">
            BugNexus
          </CardTitle>
          <p className="text-xs text-muted-foreground font-mono mt-1">QA TRIAGE SYSTEM</p>
        </CardHeader>
        <CardContent className="space-y-6 pt-4">
          <div className="text-center">
            <h2 className="text-lg font-heading font-bold uppercase tracking-wider mb-2">
              {t('auth.login')}
            </h2>
            <p className="text-sm text-muted-foreground font-body">
              {t('auth.loginDesc')}
            </p>
          </div>

          <div className="bg-muted/30 rounded-sm p-4 border border-border/40">
            <p className="text-xs text-muted-foreground font-mono text-center">
              {t('auth.devOnly')}
            </p>
          </div>

          <Button
            onClick={login}
            className="w-full font-heading font-bold uppercase tracking-wider py-6"
            data-testid="google-login-btn"
          >
            <LogIn className="w-5 h-5 mr-2" />
            {t('auth.loginBtn')}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
